module.exports = __webpack_public_path__ + "static/media/tag_anquan.dbdf3c64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/tag_anquan.svg
// module id = 770
// module chunks = 0